import { MenuSectionModel } from './menu-section.model';

export class AppHotelModel {
  id: number;
  facebook_id: number;
  name: string;
  contact_name: string;
  contact_phone: string;
  contact_email: string;
  call_center: string;
  master_color: string;
  activated: boolean;
  address: string;
  post_code: string;
  city: string;
  country: string;
  currency_code: string;
  languages: string;
  place_id: string;
  image_url: string;
  rating: number;
  web_site_url: string;
  lat_lng: string;
  online_reservation_url: string;
  direct_reservation: boolean;
  reservation_mail_address: string;
  sp_doctor: string;
  sp_reception: string;
  sp_room_service: string;
  sp_customer_relation: string;
  sp_technical_service: string;
  sp_management: string;
  plan_image_url: string;
  sm_youtube_url: string;
  sm_instagram_url: string;
  sm_facebook_url: string;
  sm_twitter_url: string;
  sm_vkontakte_url: string;
  photos: string;
  group_hotels: string;
  google_analytics_link: string;
  yandex_metrica_link: string;
  bing_link: string;
  survey_url: string;
  hotel_information_tr: string;
  hotel_information_en: string;
  hotel_information_ru: string;
  hotel_information_de: string;
  hotel_information_fr: string;
  hotel_information_ar: string;
  hotel_information_ir: string;
  hotel_information_es: string;
  sub_color: string;
  privacy_policy_link: string;
  kvkk_link: string;
  survey_title: string;
  survey_description: string;
  delivery_time_of_day: string;
  online_check_in: boolean;
  online_check_in_image: boolean;
  online_check_in_signature: boolean;
  check_in_post_message: string;
  welcome_message: string;
  app_store_link: string;
  google_play_link: string;
  firebase_link: string;
  one_signal_app_id: string;
  one_signal_app_key: string;
  one_signal_user_key: string;
  open_for_year: boolean;
  open_date: Date;
  close_date: Date;
  entry_date: Date;
  release_date: Date;
  baby_age_range: string;
  child_age_range: string;
  old_age_range: string;
  close_request: boolean;
  call_for_requests: boolean;
  rooms: MenuSectionModel;
  room_data: string[];
  claim_tracking_manager: boolean;
  hotel_type: string;
  mobile_payment: boolean;
  title: string;
  description: string;
  sub_domain_name: string;
  wifi_name: string;
  wifi_password: string;
  whatsapp_no: string;
  viber_no: string;
  telegram_no: string;
  messenger_address: string;
  google_map_address: string;
  show_welcome: boolean;
  show_chat: boolean;
  product_type: string;
  in_house_list_login_type: string;
  first_level_alert_list: string;
  second_level_alert_list: string;
  third_level_alert_list: string;
  fourth_level_alert_list: string;
  negative_survey_alert_list: string;
  auto_send_welcome_mail: boolean;
  manuel_guest_visit_confirmation: boolean;
  reward_calculation_type: 'Order Amount %' | 'Order Count for Month' | 'Order Amount for Month';
  reward_min_point: number;
  reward_value: number;
  delivery_distance_type: 'mil' | 'km';
  guestny: MenuSectionModel;

  constructor(
    id = 0,
    facebook_id = 0,
    name = '',
    contact_name = '',
    contact_phone = '',
    contact_email = '',
    call_center = '',
    master_color = '',
    activated: boolean = false,
    address = '',
    post_code = '',
    city = '',
    country = '',
    currency_code = '',
    languages = '',
    place_id = '',
    image_url = '',
    rating = 0,
    web_site_url = '',
    lat_lng = '',
    online_reservation_url = '',
    direct_reservation: boolean = false,
    reservation_mail_address = '',
    sp_doctor = '',
    sp_reception = '',
    sp_room_service = '',
    sp_customer_relation = '',
    sp_technical_service = '',
    sp_management = '',
    plan_image_url = '',
    sm_youtube_url = '',
    sm_instagram_url = '',
    sm_facebook_url = '',
    sm_twitter_url = '',
    sm_vkontakte_url = '',
    photos = '',
    group_hotels = '',
    google_analytics_link = '',
    yandex_metrica_link = '',
    bing_link = '',
    survey_url = '',
    hotel_information_tr = '<p> </p>',
    hotel_information_en = '<p> </p>',
    hotel_information_ru = '<p> </p>',
    hotel_information_de = '<p> </p>',
    hotel_information_fr = '<p> </p>',
    hotel_information_ar = '<p> </p>',
    hotel_information_ir = '<p> </p>',
    hotel_information_es = '<p> </p>',
    sub_color = '',
    privacy_policy_link = '',
    kvkk_link = '',
    survey_title = '',
    survey_description = '',
    delivery_time_of_day = '14:00',
    online_check_in: boolean = false,
    online_check_in_image: boolean = false,
    online_check_in_signature: boolean = false,
    check_in_post_message = '',
    welcome_message = '',
    app_store_link = '',
    google_play_link = '',
    firebase_link = '',
    one_signal_app_id = '',
    one_signal_app_key = '',
    one_signal_user_key = '',
    open_for_year: boolean = true,
    open_date = new Date(),
    close_date = new Date(),
    entry_date = new Date(),
    release_date = new Date(),
    baby_age_range = '',
    child_age_range = '',
    old_age_range = '',
    close_request: boolean = false,
    call_for_requests: boolean = false,
    claim_tracking_manager: boolean = false,
    hotel_type = '',
    mobile_payment: boolean = false,
    title = '',
    description = '',
    sub_domain_name = '',
    wifi_name = '',
    wifi_password = '',
    whatsapp_no = '',
    viber_no = '',
    telegram_no = '',
    messenger_address = '',
    google_map_address = '',
    show_welcome = false,
    show_chat = false,
    product_type = '',
    in_house_list_login_type = '',
    auto_send_welcome_mail = false,
    manuel_guest_visit_confirmation = false
  ) {
    this.id = id;
    this.facebook_id = facebook_id;
    this.name = name;
    this.contact_name = contact_name;
    this.contact_phone = contact_phone;
    this.contact_email = contact_email;
    this.call_center = call_center;
    this.master_color = master_color;
    this.activated = activated;
    this.address = address;
    this.post_code = post_code;
    this.city = city;
    this.country = country;
    this.currency_code = currency_code;
    this.languages = languages;
    this.place_id = place_id;
    this.image_url = image_url;
    this.rating = rating;
    this.web_site_url = web_site_url;
    this.lat_lng = lat_lng;
    this.online_reservation_url = online_reservation_url;
    this.direct_reservation = direct_reservation;
    this.reservation_mail_address = reservation_mail_address;
    this.sp_doctor = sp_doctor;
    this.sp_reception = sp_reception;
    this.sp_room_service = sp_room_service;
    this.sp_customer_relation = sp_customer_relation;
    this.sp_technical_service = sp_technical_service;
    this.sp_management = sp_management;
    this.plan_image_url = plan_image_url;
    this.sm_youtube_url = sm_youtube_url;
    this.sm_instagram_url = sm_instagram_url;
    this.sm_facebook_url = sm_facebook_url;
    this.sm_twitter_url = sm_twitter_url;
    this.sm_vkontakte_url = sm_vkontakte_url;
    this.photos = photos;
    this.group_hotels = group_hotels;
    this.google_analytics_link = google_analytics_link;
    this.yandex_metrica_link = yandex_metrica_link;
    this.bing_link = bing_link;
    this.survey_url = survey_url;
    this.hotel_information_tr = hotel_information_tr;
    this.hotel_information_en = hotel_information_en;
    this.hotel_information_ru = hotel_information_ru;
    this.hotel_information_de = hotel_information_de;
    this.hotel_information_fr = hotel_information_fr;
    this.hotel_information_ar = hotel_information_ar;
    this.hotel_information_ir = hotel_information_ir;
    this.hotel_information_es = hotel_information_es;
    this.sub_color = sub_color;
    this.privacy_policy_link = privacy_policy_link;
    this.kvkk_link = kvkk_link;
    this.survey_title = survey_title;
    this.survey_description = survey_description;
    this.delivery_time_of_day = delivery_time_of_day;
    this.online_check_in = online_check_in;
    this.online_check_in_image = online_check_in_image;
    this.online_check_in_signature = online_check_in_signature;
    this.check_in_post_message = check_in_post_message;
    this.welcome_message = welcome_message;
    this.app_store_link = app_store_link;
    this.google_play_link = google_play_link;
    this.firebase_link = firebase_link;
    this.one_signal_app_id = one_signal_app_id;
    this.one_signal_app_key = one_signal_app_key;
    this.one_signal_user_key = one_signal_user_key;
    this.open_for_year = open_for_year;
    this.open_date = open_date;
    this.close_date = close_date;
    this.entry_date = entry_date;
    this.release_date = release_date;
    this.baby_age_range = baby_age_range;
    this.child_age_range = child_age_range;
    this.old_age_range = old_age_range;
    this.close_request = close_request;
    this.call_for_requests = call_for_requests;
    this.claim_tracking_manager = claim_tracking_manager;
    this.hotel_type = hotel_type;
    this.mobile_payment = mobile_payment;
    this.title = title;
    this.description = description;
    this.sub_domain_name = sub_domain_name;
    this.wifi_name = wifi_name;
    this.wifi_password = wifi_password;
    this.whatsapp_no = whatsapp_no;
    this.viber_no = viber_no;
    this.telegram_no = telegram_no;
    this.messenger_address = messenger_address;
    this.google_map_address = google_map_address;
    this.show_welcome = show_welcome;
    this.show_chat = show_chat;
    this.product_type = product_type;
    this.in_house_list_login_type = in_house_list_login_type;
    this.auto_send_welcome_mail = auto_send_welcome_mail;
    this.manuel_guest_visit_confirmation = manuel_guest_visit_confirmation;
  }
}
